<template>
  <!-- RouteOutlet prevents raw RouterView components from flowing into parent
       keep-alive chains, which removes the Vue Router warning for nested route
       shells while keeping the route tree structure unchanged. -->
  <router-view v-slot="{ Component }">
    <component :is="Component" />
  </router-view>
</template>
